import React from "react";
import { MetaTags } from "react-meta-tags";
import Bookmarked from "../components/Dashboard/Bookmarked";
import { Tabs } from "antd";
import UserOwner from "../components/Dashboard/UserHeader";

const tabItems = [{ key: "1", label: "BOOKMARKED", children: <Bookmarked /> }];

const UserDashboard = () => {
  return (
    <>
      <MetaTags>
        <title>Physician Blogs - Dashboard</title>
      </MetaTags>

      <UserOwner />

      <div
        className="container-fluid max-w-screen-xl m-auto subnav flex overflow-auto"
        style={{ padding: "24px 14px", width: "100%", flexDirection: "column" }}
      >
        <Tabs
          className="dashboard-tabs"
          defaultActiveKey="1"
          items={tabItems}
        />
      </div>
    </>
  );
};

export default UserDashboard;
